import React from 'react';
import { rootClsPrefix as clsPrefix } from '../constants';

export const AiraTooltip = ({ title, description }) => {
  return (
    <div className={`${clsPrefix}-tooltip`}>
      <div>{title}</div>
      <div className={`${clsPrefix}-description`}>{description}</div>
    </div>
  );
};
